import React, { useEffect } from "react";
import { View, StyleSheet, StyleProp, ViewStyle, DimensionValue } from "react-native";
import Animated, {
    useSharedValue,
    useAnimatedStyle,
    withRepeat,
    withTiming,
    interpolate,
    Extrapolation,
    Easing
} from "react-native-reanimated";
import LinearGradient from "react-native-linear-gradient";
import { appColors } from "zen-core-elements/src/shared/constants";

interface ZenSkeletonProps {
    width?: DimensionValue;
    height?: DimensionValue;
    borderRadius?: number;
    style?: StyleProp<ViewStyle>;
}

const ZenSkeleton: React.FC<ZenSkeletonProps> = ({
    width = "100%",
    height = 20,
    borderRadius = 4,
    style,
}) => {
    const translateX = useSharedValue(-100);

    useEffect(() => {
        translateX.value = withRepeat(
            withTiming(100, { duration: 1000, easing: Easing.linear }),
            -1,
            false
        );
    }, []);

    const animatedStyle = useAnimatedStyle(() => {
        return {
            transform: [{ translateX: `${interpolate(translateX.value, [-100, 100], [-100, 100], Extrapolation.CLAMP)}%` }],
        };
    });

    return (
        <View
            style={[
                styles.container,
                { width, height, borderRadius, overflow: "hidden" },
                style,
            ]}
        >
            <Animated.View style={[StyleSheet.absoluteFill, animatedStyle]}>
                <LinearGradient
                    colors={[
                        appColors.light,
                        "#F0F0F0",
                        appColors.light,
                    ]}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 0 }}
                    style={StyleSheet.absoluteFill}
                />
            </Animated.View>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        backgroundColor: appColors.lightGrey,
        overflow: "hidden",
    },
});

export default ZenSkeleton;
